import SET_USER from './types';
export default {
  [SET_USER](state, payload) {
    var currentState = state;
    currentState.user = payload;
  }

};